"use client";

import styles from "./LoginRememberMeCheckbox.module.scss";

import { useTranslations } from "@/i18n";
import { Checkbox } from "@vetty/ui";

/**
 * LoginRememberMeCheckbox Component
 *
 * Checkbox for "Remember me" functionality in login form.
 * Allows users to stay logged in on the current device.
 */
export const LoginRememberMeCheckbox = () => {
  const t = useTranslations("login.form");

  /**
   * Handles checkbox state changes
   * Currently logs the value - should be connected to form state
   */
  const handleCheckboxChange = (checked: boolean) => {
    console.log(checked);
    // TODO: Connect to form state management
  };

  return (
    <div className={styles["comp"]}>
      <Checkbox
        id={"rememberMe"}
        key={"rememberMe"}
        onChange={handleCheckboxChange}
      >
        <Checkbox.Label>{t("rememberMe")}</Checkbox.Label>
      </Checkbox>
    </div>
  );
};
